import { RendererProvider, PortalMountNodeProvider } from '@fluentui/react-components';
import { createShadowDOMRenderer } from '@griffel/shadow-dom';
import * as React from 'react';
import { createProxy } from 'react-shadow';
const ReactComponentsWrapper = ({ children , root  })=>{
    const renderer = React.useMemo(()=>createShadowDOMRenderer(root), [
        root
    ]);
    return /*#__PURE__*/ React.createElement(RendererProvider, {
        renderer: renderer
    }, /*#__PURE__*/ React.createElement(PortalMountNodeProvider, {
        value: root
    }, children));
};
export const root = createProxy({}, '@fluentui/react-components', ({ children , root  })=>/*#__PURE__*/ React.createElement(ReactComponentsWrapper, {
        root: root
    }, children));

//# sourceMappingURL=root.js.map